import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-beta-indicator',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './beta-indicator.component.html',
  styleUrls: ['./beta-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BetaIndicatorComponent {}
